// import { GiftNotesService } from '@services/giftNotes'
// import { store } from '@/store'
// import LoadingPromiseUtil from '@utils/loadingPromise'
import OnboardingStep from '@models/onboarding/onboardingStep'
import OnboardingUserInfo from '@models/onboarding/onboardingUserInfo'
import { OnboardingSteps, ActiveOnboardingSteps } from '@enums/modules/onboarding/onboardingSteps'
import { OnboardingStepEvents } from '@enums/modules/onboarding/onboardingStepEvents'
import { GoodFitOptions } from '@enums/modules/onboarding/goodFitOptions'
import { HazmatOptions } from '@enums/modules/onboarding/hazmatOptions'
import { OnboardingService } from '../../../services/onboarding'
import ShipbobAppSettings from '@/appSettings/appSetting'
import { sendPendingEvents, addEvent, checkAllEventAreSent } from './onbardingWizardEventStore'

const defineStepTo = (steps, stepFrom, stepTo, shouldHideCostPage) => {
  if (stepFrom === OnboardingSteps.ShipBobGoodFit &&
    stepTo === OnboardingSteps.ShippingHazmat) {
    var goodfit = steps.find(s => s.Id === OnboardingSteps.ShipBobGoodFit)
    if (goodfit && goodfit.State && goodfit.State.Selected !== GoodFitOptions.NoneOfThem) {
      return OnboardingSteps.CantShipWithUs
    }
  }
  if (stepFrom === OnboardingSteps.ShippingHazmat &&
    stepTo === OnboardingSteps.StoreSelection) {
    var hazmat = steps.find(s => s.Id === OnboardingSteps.ShippingHazmat)
    if (hazmat && hazmat.State && hazmat.State.Selected === HazmatOptions.NotAceptedItems) {
      return OnboardingSteps.CantShipWithUs
    }
  }
  if (stepTo === OnboardingSteps.CostCalculator && shouldHideCostPage) {
    return undefined
  }
  if (stepFrom === OnboardingSteps.CostCalculator && stepTo === OnboardingSteps.CantShipWithUs) {
    return undefined
  }

  return stepTo
}

const getStateStorageKey = (state, stepId) => {
  return `OnboardingWizardActiveStepState-${state.ImpersonatedUserId}-${stepId}`
}

const storeStepState = (state, stepId, stepState) => {
  window.localStorage.setItem(getStateStorageKey(state, stepId), JSON.stringify(stepState))
}

const getStepState = (state, stepId) => {
  return JSON.parse(window.localStorage.getItem(getStateStorageKey(state, stepId)))
}

const clearStepStateStorage = (state) => {
  state.Steps.forEach(step => {
    window.localStorage.removeItem(getStateStorageKey(state, step.Id))
  })
}

export default {
  namespaced: true,
  state: {
    ActiveStep: OnboardingSteps.ShipBobGoodFit,
    Completed: false,
    Steps: [
      new OnboardingStep({ Id: OnboardingSteps.ShipBobGoodFit, State: undefined }),
      new OnboardingStep({ Id: OnboardingSteps.ShippingHazmat, State: undefined }),
      new OnboardingStep({ Id: OnboardingSteps.StoreSelection, State: undefined }),
      new OnboardingStep({ Id: OnboardingSteps.CostCalculator, State: undefined }),
      new OnboardingStep({ Id: OnboardingSteps.CantShipWithUs, State: undefined })
    ],
    OnboardingShown: false,
    OnboardingUserInfo: new OnboardingUserInfo({ UtmSource: '', NumberOfShipmentsPerMonth: 0 })
  },
  mutations: {
    setOnboardingStepState (state, { id, stepState }) {
      state.Steps.find(s => s.Id === id).State = stepState
      storeStepState(state, id, stepState)
    },
    setOnboardingState (state, { newState, impersonatedUserId }) {
      state.ActiveStep = newState.ActiveStep
      state.Completed = newState.Completed
      state.OnboardingShown = newState.OnboardingShown
      state.OnboardingUserInfo = newState.OnboardingUserInfo
      state.ImpersonatedUserId = impersonatedUserId
      // Merge the new incomming steps and the default values to make sure
      // that we only show steps that the front end support.
      var defaultSteps = state.Steps.filter(x => !newState.Steps.find(s => s.Id === x.Id))
      var mergedSteps = defaultSteps.concat(newState.Steps.filter(x => ActiveOnboardingSteps.includes(x.Id)))
      state.Steps = mergedSteps.sort((a, b) => ActiveOnboardingSteps.findIndex(x => x === a.Id) - ActiveOnboardingSteps.findIndex(x => x === b.Id))
      state.Steps.find(s => s.Id === newState.ActiveStep).State = getStepState(state, newState.ActiveStep)
    },
    setOnboardingActiveStep (state, activeStep) {
      state.ActiveStep = activeStep
    },
    setOnboardingShown (state, onboardingShown) {
      state.OnboardingShown = onboardingShown
    },
    setOnboardingCompleted (state) {
      state.ActiveStep = undefined
      state.Completed = true
      clearStepStateStorage(state)
    }
  },
  actions: {
    setOnboardingStepState (context, { id, stepState }) {
      context.commit('setOnboardingStepState', { id, stepState })
    },
    async setOnboardingCompleted (context, stepId) {
      context.commit('setOnboardingCompleted')
      var impersonatedUserId = context.rootGetters['user/getUser'].impersonatedUserId
      addEvent(impersonatedUserId, stepId, OnboardingStepEvents.OnboardingCompleted, 'true')
      await sendPendingEvents(impersonatedUserId)
    },
    async setOnboardingActiveStep (context, { stepFrom, stepTo }) {
      context.commit('setOnboardingActiveStep', stepTo)
      if (stepFrom && stepTo) {
        var impersonatedUserId = context.rootGetters['user/getUser'].impersonatedUserId
        await addEvent(impersonatedUserId, stepFrom, OnboardingStepEvents.StepViewChange, stepTo)
        await sendPendingEvents(impersonatedUserId)
      }
    },
    async setOnboardingChangeActiveStep (context, { id, direction }) {
      var stepIndex = context.state.Steps.findIndex(s => s.Id === id)

      if ((stepIndex > 0 && direction === -1) || (stepIndex >= 0 && direction === 1)) {
        var nextStep = context.state.Steps[ stepIndex + direction ]
        var shouldHideCostPage = context.getters['shouldHideCostPage']
        var stepTo = defineStepTo(context.state.Steps, id, nextStep.Id, shouldHideCostPage)
        await context.dispatch('setOnboardingActiveStep', { stepFrom: id, stepTo })
      }
    },
    async setOnboardingStepBack (context, id) {
      await context.dispatch('setOnboardingChangeActiveStep', {id, direction: -1})
    },
    async setOnboardingStepNext (context, id) {
      await context.dispatch('setOnboardingChangeActiveStep', {id, direction: 1})
    },
    setOnboardingState (context, newState) {
      var impersonatedUserId = context.rootGetters['user/getUser'].impersonatedUserId
      context.commit('setOnboardingState', { newState, impersonatedUserId })
    },
    setOnboardingShown (context, onboardingShown) {
      context.commit('setOnboardingShown', onboardingShown)
    },
    async loadOnboardingState (context, qs) {
      if (context.rootGetters['user/getUser'].isOnboarding) {
        var newState = await OnboardingService.fetchStepState()
        if (newState) {
          var impersonatedUserId = context.rootGetters['user/getUser'].impersonatedUserId
          context.commit('setOnboardingState', { newState, impersonatedUserId })
        }
      }
    },
    async setOnboardingStepEvent (context, { stepId, eventId, eventValue }) {
      var impersonatedUserId = context.rootGetters['user/getUser'].impersonatedUserId
      if ([
        OnboardingStepEvents.StepViewChange,
        OnboardingStepEvents.OnboardingCompleted,
        OnboardingStepEvents.CantShipWithUsSelected
      ].includes(eventId)) {
        await addEvent(impersonatedUserId, stepId, eventId, eventValue)
        await sendPendingEvents(impersonatedUserId)
      } else {
        await addEvent(impersonatedUserId, stepId, eventId, eventValue)
      }
    },
    async checkAllEventAreSent (context) {
      var impersonatedUserId = context.rootGetters['user/getUser'].impersonatedUserId
      await checkAllEventAreSent(impersonatedUserId)
    }
  },
  getters: {
    steps: state => state.Steps,
    activeStep: state => state.ActiveStep,
    completed: state => state.Completed,
    onboardingShown: state => state.OnboardingShown,
    onboardingUserInfo: state => state.OnboardingUserInfo,
    shouldHideCostPage: state => state.OnboardingUserInfo &&
      !state.OnboardingUserInfo.UtmSource.toLowerCase().includes(ShipbobAppSettings.OnboardingWizard.BdrGrowthUtmSource.toLowerCase()) &&
      state.OnboardingUserInfo.NumberOfShipmentsPerMonth >= parseInt(ShipbobAppSettings.OnboardingWizard.HideCostCalculatorMinShipmentsPerMonth, 10)
  }
}
